import React from "react";

export default function UserMenuItem({url, children}) {
    return <a href={url} className="text-dark font-size-0-875 line-height-5 px-2 border-bottom mb-npixel d-flex align-items-center text-nowrap">
        {children}
    </a>
}